export interface Command {
  command: {
    commandData: unknown
    commandType: string
    notes: string
    accountId: number
  }
  commandId: string
  createdTs: string | Date
  parentCommandId: string
  sessionId: string
  userId: number
  needsReview: boolean
}

export type RunType = 'CUSTODY' | 'TRADING'

export enum RestrictedActionRequestTypes {
  FORCE_RECON = 'FORCE_RECON',
  RESTRICTED_BREAK = 'RESTRICTED_BREAK',
}

export interface CreateRestrictedActionRequest {
  actionType: RestrictedActionRequestTypes
  accountIds: number[]
  reconDates: string[]
  comment?: string
  metadata?: {
    runEtls: boolean
    runType: RunType
    sessionId: string
    breakIds: string[]
    totalCommands: number
  }
}
